var minHebLet = "א".charCodeAt(0);
var maxHebLet = "ת".charCodeAt(0);
function IsHebrewLet(c) {
	var code = c.charCodeAt(0);
	return code >= minHebLet && code <= maxHebLet;
}
function AnyArentPrefixLetters(l) {
	for (var iItem = 0; iItem < l.length; iItem++) {
        if ("משהוכלב".indexOf(l[iItem]) == -1)
            return true;
    }// next item in list
    return false;
}
function ProcessNikudSingleLineIntoStructureImpl(line) {
	var ret = [];
    // strip nikud
    line = line.replace(/[\u0591-\u05C7]/, '');
    
    var curWord = [];
    var curSep = []
    // we want to go through all the characters
    var iChar;
    for (iChar = 0; iChar < line.length; iChar++) {
        var curChar = line[iChar];
        // Hebrew letter? just put it in
        if (IsHebrewLet(curChar)) {
            // Do we have a separator? add it in
            if (curSep.length > 0) {
                ret.push({ "word": curSep.join(""), "sep": true });
                curSep = [];
            }
            curWord.push(curChar);
            continue;
        }
        
        // It's not a Hebrew character! 
        // No word? continue
        if (curWord.length == 0) {
            curSep.push(curChar);
            continue;
        }
        
        // We need to determine if this is considered 
        // part of the word or not.
        if (curChar == '"' || curChar == "'") {
            // It's quote - might be a separator, might not.
            // If there is a hebrew letter afterward - it might not be.
            if (iChar + 1 < line.length && IsHebrewLet(line[iChar + 1])) {
                // If we have a non-prefix letter at the beginning, then
                // it is a regular quote mark and can go in
                if (AnyArentPrefixLetters(curWord)) {
                    curWord.push(curChar); continue;
                }
                // Otherwise, we have a word that's only prefix letters,
                // and is followed by a quotemark. If there aren't (at least)
                // two letters afterwards, make it part of the word.
                if (iChar + 2 >= line.length || !IsHebrewLet(line[iChar + 2])) {
                    curWord.push(curChar); continue;
                }
            }
            // Final check: If it's a single quote at the end of a word:
            if (curChar == "'") {
                // The live nakdan won't separate the apostrophe at the end of a line
                // but the new nakdan that will be published in the next round will
                // When you update, switch the following lines:
                // New line to use:
                if (iChar + 1 == line.length || (iChar + 1 < line.length && !IsHebrewLet(line[iChar + 1]))) {
                // Old line to use now:
                // if (iChar + 1 < line.length && !IsHebrewLet(line[iChar + 1])) {
                    curWord.push(curChar); continue;
                }
            }            
        }// end of check for quote
        // We finished checking for quotes - add in the word!
        ret.push({ "word": curWord.join(""), "sep": false });
        curSep.push(curChar);
        curWord = [];
    }// next character
    
    // Add the final word/sep - will never have both, always have one.
    if (curWord.length > 0)
        ret.push({ "word": curWord.join(""), "sep": false });
    if (curSep.length > 0)
        ret.push({ "word": curSep.join(""), "sep": true });
    
    return ret;
}

export function processNikudSingleLineIntoStructure (line) {
    return ProcessNikudSingleLineIntoStructureImpl(line).map(o => Object.assign(o, {reinsertionChars: [], options: []}))
}